import axios from "axios";
import queryString from 'query-string';
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";
import { schema as studentSchema } from './updateStudentInfo';

export const schema = Joi.array().items(studentSchema);

export default function createBulkStudent(schoolId, studentArray) {

  if(!schoolId){
    throw 'missing school ID'
  }
  let validateResult = Joi.validate(studentArray, schema);

  if (validateResult.error) {
    return new Promise((resolve, reject)=> {
      reject(validateResult);
    });
  }

  return new Promise((resolve, reject) => {
    axios.put(APIAddress, {'uri': `/stu_bulk_create/${schoolId}/`,
		'method': 'POST',
		'data': JSON.stringify(studentArray),
		'token': localStorage.getItem('token')})
    .then(({data}) => {
      resolve(data);
    })
    .catch((err) => {
      reject(err);
    })
  })
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/student/createBulkStudent.js